import { fetchAuthProviders } from '../api/auth_provider'
import { Resolvers } from '../generated/resolvers'

const AuthProviderResolver: Resolvers = {
  Query: {
    authenticationProviders: () => fetchAuthProviders(),
  },
}

export default AuthProviderResolver
